<template>
  <div v-if="data">
    <div>
      <upload-profile :readonly="!isEdit" v-model="data.profile_pic" :height="120"></upload-profile>
    </div>
    <v-layout row wrap class="mt-4 px-5 mb-0">
      <!-- <v-flex v-if="!isEdit" xs12>
        <div class="text-xs-right">
          <v-btn @click="showEdit" icon> <v-icon>edit</v-icon></v-btn>
        </div>
      </v-flex> -->

      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <Typography medium style="width: 40%" h5 label="รหัสสมาชิก :" />
        <Typography medium h5 :label="data.memberid ? data.memberid : '-'" />
      </v-flex>

      <template v-if="data.membertype == 'มหาวิทยาลัย'">
        <v-flex xs12 sm12 class="form-control" style="display: flex">
          <div style="width: 10%"></div>
          <Typography medium style="width: 40%" h5 label="ชื่อคณะ :" />
          <div v-if="isEdit">
            <input v-model="data.faculty" type="text" class="depainput rsu" />
          </div>
          <Typography v-else medium h5 :label="data.faculty ? data.faculty : '-'" />
        </v-flex>

        <v-flex xs12 sm12 class="form-control" style="display: flex">
          <div style="width: 10%"></div>
          <Typography medium style="width: 40%" h5 label="รหัสคณะ :" />
          <div v-if="isEdit">
            <input v-model="data.faculty_id" type="text" class="depainput rsu" />
          </div>
          <Typography v-else medium h5 :label="data.faculty_id ? data.faculty_id : '-'" />
        </v-flex>
      </template>

      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <Typography medium style="width: 40%" h5 label="เลขบัตรประจำตัวประชาชน :" />
        <div v-if="isEdit">
          <input v-model="data.id_card" type="text" class="depainput rsu" />
        </div>
        <Typography v-else medium h5 :label="data.id_card ? data.id_card : '-'" />
      </v-flex>

      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <Typography medium style="width: 40%" h5 label="ชื่อ - นามสกุล :" />
        <div v-if="isEdit">
          <input v-model="data.name" type="text" class="depainput rsu" />
        </div>
        <Typography v-else medium h5 :label="data.name ? data.name : '-'" />
      </v-flex>

      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <!-- <div style="width: 40%;display: flex;align-items: center;" class="fs-16 bold5">
          วันเกิด :
        </div> -->
        <Typography medium style="width: 40%" h5 label="วันเกิด :" />
        <div v-if="isEdit" style="width: 39%;">
          <date-picker
            class="mb-2"
            :append-to-body="false"
            :clearable="true"
            :editable="false"
            input-class="dateSearch"
            name="DateSearch"
            v-model="data.dob"
            valueType="date"
            format="DD/MM/YYYY"
            :placeholder="$t('เลือกวันที่เริ่ม')"
            confirm
          >
            <template v-slot:footer="{ emit }">
              <div style="text-align: left">
                <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
              </div>
            </template>
          </date-picker>
        </div>
        <Typography v-else medium h5 :label="data.dob ? formatDate(data.dob) : '-'" />
      </v-flex>
      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <Typography medium style="width: 40%" h5 label="เบอร์ :" />
        <div v-if="isEdit">
          <input v-if="isEdit" v-model="data.phone_number" type="text" class="depainput rsu" />
        </div>
        <Typography v-else medium h5 :label="data.phone_number ? data.phone_number : '-'" />
      </v-flex>

      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <Typography medium style="width: 40%" h5 label="อีเมล :" />
        <div v-if="isEdit">
          <input v-if="isEdit" v-model="data.email" type="text" class="depainput rsu" />
        </div>
        <Typography v-else medium h5 :label="data.email ? data.email : '-'" />
      </v-flex>

      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <Typography medium style="width: 40%" h5 label="ประเภทสมาชิก :" />
        <Typography medium h5 :label="data.membertype ? data.membertype : '-'" />
      </v-flex>

      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <Typography medium style="width: 40%" h5 label="สถานะ DP :" />
        <Typography medium h5 :label="data.dptype ? data.dptype : '-'" />
      </v-flex>

      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%"></div>
        <Typography medium style="width: 40%" h5 label="เข้าร่วมวันที่ :" />
        <Typography medium h5 :label="data.created ? data.created : '-'" />
      </v-flex>
      <v-flex v-if="isEdit" xs12 sm12 style="display: flex" class="form-control pr-4 mb-2">
        <div class="pl-5">
          <v-checkbox hide-details v-model="data.admin" color="primary" label="Admin"></v-checkbox>
        </div>
      </v-flex>
      <!-- <v-flex xs12 sm6 class="form-control pr-2 mb-2">
        <div style="line-height: 26.99px" class="greytext">{{ $t('วันเดือนปีเกิด') }}</div>

        <DatePickerWithoutButton v-if="isEdit" v-model="data.dob">
          <input readonly :value="data.dob" type="text" class="depainput rsu" />
        </DatePickerWithoutButton>
        <div v-else>
          {{ data.dob ? data.dob : '-' }}
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="form-control mb-2">
        <div style="line-height: 26.99px" class="greytext">
          {{ $t('เลขบัตรประจำตัวประชาชน') }}
        </div>
        <input v-if="isEdit" v-model="data.id_card" type="text" class="depainput rsu" />
        <div v-else>{{ data.id_card ? data.id_card : '-' }}</div>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pr-2 mb-2">
        <div style="line-height: 26.99px" class="greytext">{{ $t('Email') }}</div>
        <input v-if="isEdit" v-model="data.email" type="text" class="depainput rsu" />
        <div v-else>{{ data.email ? data.email : '-' }}</div>
      </v-flex>
      <v-flex xs12 sm6 class="form-control mb-2">
        <div style="line-height: 26.99px" class="greytext">{{ $t('Phone') }}</div>
        <input v-if="isEdit" v-model="data.phone_number" type="text" class="depainput rsu" />
        <div v-else>{{ data.phone_number ? data.phone_number : '-' }}</div>
      </v-flex>

      <v-flex xs12 sm6 class="form-control pr-2 mb-2">
        <div style="line-height: 26.99px" class="greytext">{{ $t('ประเภทสมาชิก') }}</div>
        <DropdownMenu
          v-if="isEdit"
          v-model="data.membertype"
          textLabel="type"
          textValue="type"
          :options="$store.state.depamembertype"
          readonly
        >
          <input :value="data.membertype" readonly type="text" class="depainput rsu" disabled />
        </DropdownMenu>
        <div v-else>
          {{ data.membertype ? data.membertype : '-' }}
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pr-2 mb-2">
        <div style="line-height: 26.99px" class="greytext">{{ $t('ประเภท') }}</div>

        <DropdownMenu v-if="isEdit" v-model="data.dptype" :options="['DP', 'Non-DP']">
          <input
            placeholder="DP type"
            :value="data.dptype"
            readonly
            type="text"
            class="depainput rsu"
          />
        </DropdownMenu>
        <div v-else>
          {{ data.dptype ? data.dptype : '-' }}
        </div>
      </v-flex>

      <v-flex v-if="isEdit" xs12 sm12 style="display: flex" class="form-control pr-4 mb-2">
        <div class="pl-5">
          <v-checkbox hide-details v-model="data.admin" color="primary" label="Admin"></v-checkbox>
        </div>
      </v-flex> -->
    </v-layout>
    <div v-if="data.techprovidername">
      <div class="px-5 py-2 mt-5">
        <Typography bold h2 label="ข้อมูลร้านค้า" />
      </div>
      <MemberInfoEditInformation
        @saveedit="editData"
        :isEdit="isEdit"
        :infodata="data"
        @closemodal="$emit('closemodal')"
      ></MemberInfoEditInformation>
    </div>
    <div v-if="isEdit" class="mt-5" style="display: flex; justify-content: center">
      <Button :loading="loading" outline :label="$t('cancel')" @click="cancelEdit" />
      <Button :loading="loading" depressed :label="$t('Save')" @click="editData" />
    </div>

    <!-- <div v-if="isEdit" class="text-xs-center mt-5">
      <v-btn @click="cancelEdit" round small outline color="primary">{{ $t('cancel') }}</v-btn>
      <v-btn
        @click="editData"
        round
        small
        :loading="loading"
        depressed
        style="color: #ffef01"
        color="primary"
        >{{ $t('Save') }}</v-btn
      >
    </div> -->
  </div>
</template>

<script>
import UploadProfile from '@/components/elements/UploadProfile.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
// import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import MemberInfoEditInformation from './MemberInfoEditInformation.vue'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
export default {
  props: {
    infodata: {
      default: null
    },
    isEdit: {
      default: Boolean
    }
  },
  components: {
    UploadProfile,
    DropdownMenu,
    // DatePickerWithoutButton,
    MemberInfoEditInformation,
    Typography,
    Button,
    DatePicker
  },
  data() {
    return {
      isEdit: false,
      tempdata: '',
      loading: false,
      data: null
    }
  },
  mounted() {
    this.data = {
      ...this.infodata,
      created: moment(this.infodata.created_at).format('YYYY-MM-DD'),
      dob: moment(this.infodata.dob).toDate()
    }
    this.isEdit = this.isEdit
  },
  methods: {
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    async editData() {
      this.loading = true
      this.$swal
        .fire({
          html: '<div class="primary--text bold7 fs-24">ยืนยันการบันทึกข้อมูล</div>',
          showCancelButton: true,
          showCloseButton: true
        })
        .then(result => {
          if (result.value) {
            try {
              this.$store.dispatch('depamemberinfo', this.data)
              this.$emit('saveedit', this.data)
              this.isEdit = false
            } catch (error) {}
          }
        })
      this.loading = false
    },
    showEdit() {
      this.tempdata = JSON.stringify(this.data)
      this.isEdit = true
    },
    cancelEdit() {
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ยกเลิก</div>',
          html:
            '<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการแก้ไขข้อมูล</div>',
          showCancelButton: true,
          showCloseButton: true
        })
        .then(result => {
          if (result.value) {
            this.$emit('closemodal')
            this.data = JSON.parse(this.tempdata)
            this.isEdit = false
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.greytext {
  color: rgb(173, 173, 173);
  font-size: 13px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/memberInfo/MemberInfoEditNoTaxID.vue